<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-y: hidden;
}
.page-list-search {
  background-color: #ffffff;
  height: auto;
}
.page-list-search .first-search-item {
  margin-left: 1rem;
}
.page-list-search .top-item {
  margin-top: 0.5rem;
}
/* 去除input type=number右侧的小箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
.notset {
  text-decoration: line-through;
  color: darkgray;
}
</style>
